var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"warn-block mt-2"},[(_vm.showIcon)?_c('svg',{directives:[{name:"svg",rawName:"v-svg"}],staticClass:"icon",attrs:{"symbol":"info","size":"0 0 17 17","role":"info"}}):_vm._e(),_c('p',[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }